// extracted by mini-css-extract-plugin
export default {"aglmd-list":"jDl8naeMb_j2FI701nlG","aglmd-list--default":"a67zSP5klvK0lti_Ed3T","aglmd-list--no-padding":"wYFuUSGWOwbR6EG34UgQ","aglmd-list--comfortable":"gCgakw2PJJxU2FBxlYNE"};